export const AUTH_ROUTE_PATHS = {
  entry: "/entry",
  login: "/login",
  register: "/register",
  resetPassword: "/reset-password",
  newPassword: "/new-password",
  newPasswordOffline: "/new-password-set",
  verifiedEmail: "/verified-email",
  expiredEmail: "/expired-email",
  offlineRegistrationSuccess: "/offline-registration-success",
  offlineRegistrationSuccessWithClubCard: "/offline-registration-success-with-club-card",
  smsPhoneValidation: "/verify-phone",
  facebookLoginRedirect: "/facebook/redirect",
} as const;
